import api from '@motionelements/core/src/api/base-api-v2.js';
import { snakeCaseKeys, extractFieldsQueryParams } from '@motionelements/core/src/helpers/string.js';

// eslint-disable-next-line import/prefer-default-export
export const getArtistProfile = async (username, params) => {
  params = params || {};
  username = username.toLowerCase();
  const { rest, fieldsQuery } = extractFieldsQueryParams(params);
  return api.get(`/v2/artists/${username}`, {
    params: {
      ...api.getLocaleParams(),
      ...snakeCaseKeys(rest),
      ...fieldsQuery,
    },
  });
};
